import React, {useState} from 'react';
import IdStageUi from './IdStage.ui';

const IdStage = ({ onSubmit, data = {} }) => {
  const [idValue, setIdValue] = useState(data.id || '');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleIdChange = (value) => {
    const digits = (value || '').toString().replace(/\D/g, '').slice(0, 9);
    setIdValue(digits);
    if (error) setError('');
  };

  // Israeli ID checksum
  const isIsraeliId = (id) => {
    if (!id) return false;
    id = String(id).trim();
    if (id.length > 9 || isNaN(id)) return false;
    id = id.length < 9 ? ('00000000' + id).slice(-9) : id;
    return Array.from(id, Number).reduce((counter, digit, i) => {
      const step = digit * ((i % 2) + 1);
      return counter + (step > 9 ? step - 9 : step);
    }, 0) % 10 === 0;
  };

  const submit = async (e) => {
    if (e && e.preventDefault) e.preventDefault();

    const normalized = (idValue || '').toString().replace(/\D/g, '');
    const idPattern = /^\d{9}$/;
    if (!idPattern.test(normalized) || !isIsraeliId(normalized)) {
      setError('כנראה שיש טעות במספר, צריך להקליד את כל 9 הספרות');
      return;
    }

    if (!onSubmit) return;

    try {
      setLoading(true);
      const result = onSubmit(normalized);
      if (result && typeof result.then === 'function') {
        await result;
      }
    } catch (err) {
      setError((err && err.message) || 'שגיאה בשליחה, נסה שנית');
    } finally {
      setLoading(false);
    }
  };

  return (
    <IdStageUi
      idLabel={data.idLabel}
      title={data.title || 'ת.ז ומתקדמים'}
      idValue={idValue}
      onIdChange={handleIdChange}
      onSubmit={submit}
      loading={loading}
      error={error}
    />
  );
};

export default IdStage;

